
export const dummyLeads = [
  {
    id: "lead-001",
    name: "Dr. Amit Sharma",
    email: "amit.sharma@pharmaworld.com",
    phone: "+91 98765 43210",
    message: "We are interested in bulk procurement of Metformin HCl API for our formulation unit in Hyderabad. Please share your latest pricing and COA.",
    source: "Contact Page",
    date: "Jan 15, 2025",
    timestamp: 1736899200000
  },
  {
    id: "lead-002",
    name: "Sarah Mitchell",
    email: "s.mitchell@europharma.de",
    phone: "+49 170 1234567",
    message: "Looking for a reliable API supplier for cardiovascular drugs. Can we schedule a call to discuss partnership opportunities?",
    source: "Homepage",
    date: "Jan 12, 2025",
    timestamp: 1736640000000
  },
  {
    id: "lead-003",
    name: "Rajesh Patel",
    email: "rajesh.p@medicureind.in",
    phone: "+91 99887 76655",
    message: "We visited your booth at CPhI India 2024 and would like to follow up on the Atorvastatin Calcium API discussion. Please send us the technical dossier.",
    source: "Contact Page",
    date: "Jan 10, 2025",
    timestamp: 1736467200000
  },
  {
    id: "lead-004",
    name: "Maria Gonzalez",
    email: "maria.g@latampharma.mx",
    phone: "+52 55 1234 5678",
    message: "Our company is expanding into the Indian API market. We need a WHO-GMP certified supplier for Amoxicillin Trihydrate. Please share your product catalog.",
    source: "Homepage",
    date: "Jan 8, 2025",
    timestamp: 1736294400000
  },
  {
    id: "lead-005",
    name: "Dr. Priya Nair",
    email: "priya.nair@biosynth.co.in",
    phone: "+91 94432 11223",
    message: "Interested in your green chemistry research initiatives. Would like to explore a collaborative research project on sustainable API synthesis.",
    source: "Contact Page",
    date: "Jan 5, 2025",
    timestamp: 1736035200000
  },
  {
    id: "lead-006",
    name: "James O\u0027Brien",
    email: "james.obrien@ukpharmaco.co.uk",
    phone: "+44 7700 900123",
    message: "We require Losartan Potassium API with EU-GMP compliance. Can you provide regulatory documentation and pricing for 500 kg quarterly supply?",
    source: "Contact Page",
    date: "Jan 3, 2025",
    timestamp: 1735862400000
  },
  {
    id: "lead-007",
    name: "Ananya Deshmukh",
    email: "ananya.d@wellcurepharma.com",
    phone: "+91 87654 32109",
    message: "We are a mid-size formulation company looking for long-term API supply agreements. Interested in Ciprofloxacin HCl and Azithromycin Dihydrate.",
    source: "Homepage",
    date: "Dec 28, 2024",
    timestamp: 1735344000000
  },
  {
    id: "lead-008",
    name: "Chen Wei",
    email: "chen.wei@sinopharmagroup.cn",
    phone: "+86 138 0013 8000",
    message: "Our procurement team is evaluating new API vendors. Please share your product list, certifications, and minimum order quantities for antidiabetic APIs.",
    source: "Contact Page",
    date: "Dec 22, 2024",
    timestamp: 1734825600000
  },
  {
    id: "lead-009",
    name: "Fatima Al-Rashid",
    email: "fatima.r@gulfmedical.ae",
    phone: "+971 50 123 4567",
    message: "We are a pharmaceutical distributor in the UAE. Interested in becoming an authorized distributor for Universal Dairy products in the Middle East region.",
    source: "Homepage",
    date: "Dec 18, 2024",
    timestamp: 1734480000000
  },
  {
    id: "lead-010",
    name: "Vikram Singh",
    email: "vikram.singh@novahealthcare.in",
    phone: "+91 70123 45678",
    message: "Requesting samples of Omeprazole API for our R&D evaluation. Also need stability data and DMF details for regulatory filing purposes.",
    source: "Contact Page",
    date: "Dec 15, 2024",
    timestamp: 1734220800000
  },
  {
    id: "lead-011",
    name: "Laura Bianchi",
    email: "l.bianchi@italiafarmaci.it",
    phone: "+39 333 456 7890",
    message: "Following up from our meeting at CPHI Barcelona. We would like to proceed with the Amlodipine Besylate trial order. Please send the proforma invoice.",
    source: "Contact Page",
    date: "Dec 10, 2024",
    timestamp: 1733788800000
  },
  {
    id: "lead-012",
    name: "Suresh Kumar",
    email: "suresh.k@generikapharma.in",
    phone: "+91 96543 21098",
    message: "Need urgent quotation for Paracetamol DC Grade API, 2 metric tons, delivery within 30 days. Please confirm availability and lead time.",
    source: "Homepage",
    date: "Dec 5, 2024",
    timestamp: 1733356800000
  }
];
